import React from "react";

const UnopenedBadge = ({ count }) => {
    if (!count || count <= 0) return null;
    return (
        <span className="min-w-[20px] h-5 px-1.5 rounded-full bg-red-500 text-white ft-xs font-medium flex items-center justify-center">
            {count}
        </span>
    );
};

export default UnopenedBadge;
